<template>
    <footer class="footer">
        <div class="footer-body">
            <v-container>
                <v-row justify="space-between">
                    <v-col cols="12" md="">
                        <v-row class="row--sm">
                            <v-col cols="12">
                                <div class="pb-md-6px">
                                    <v-img eager max-width="115" :aspect-ratio="115/54" src="/images/logo.svg" />
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="inline-group">
                                    <ul>
                                        <li><div class="font-weight-medium white--text mb-12px">㈜이레아이에스</div></li>
                                        <li class="clear"><span class="grey--text text--lighten-3">본사 </span>강원도 강릉시 강릉대로 285,931호</li>
                                        <!-- <li class="clear"><span class="grey--text text--lighten-3">R&D센터 </span>서울특별시 송파구 법원로 11길 7 문정현대지식산업센터 C동 1024,1025호</li> -->
                                        <li class="clear"><span class="grey--text text--lighten-3">경기공장 </span>경기도 안양시 동안구 흥안대로 427번길 16 평촌디지털엠파이어 203호</li>
                                        <!-- <li class="clear"><span class="grey--text text--lighten-3">경남지사 </span>경상남도 진주시 동부로 169번길 12 윙스타워 C동 529호</li> -->
                                        <li class="clear"><span class="grey--text text--lighten-3">전화 </span>070-8680-0950</li>
                                        <li><span class="grey--text text--lighten-3">팩스 </span>031-423-0483</li>
                                        <li><span class="grey--text text--lighten-3">이메일 </span>ireis@ireis.co.kr</li>
                                    </ul>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="footer-copyright">
                                    <p>Copyright 2023. Ireis All Rights Reserved.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="auto" class="d-flex ml-auto">
                        <v-row align-content="space-between" class="flex-column">
                            <!-- <v-col class="d-none d-md-block">
                                <v-img max-width="114" src="/images/logo.svg" class="ml-auto" />
                            </v-col> -->
                            <v-col class="d-flex">
                                <v-row justify="end" class="row--sm mt-auto">
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://blog.naver.com/ireis2010" target="_blank"><i class="icon icon-blog" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.youtube.com/@user-ob6uq3jz6u" target="_blank"><i class="icon icon-youtube" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.facebook.com/ireis0903" target="_blank"><i class="icon icon-facebook" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.instagram.com/ireis_official/" target="_blank"><i class="icon icon-insta" /></v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </footer>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.inline-group {
    > ul {
        > li {
            font-size: 16px;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .inline-group {
        > ul {
            > li {
                font-size: 18px;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
